import React from 'react'
import { connect } from 'react-redux'
import Chats from '../feedbackdetail/Chats'
import Typing from '../feedbackdetail/Typing'
import ChatSectionButtons from './ChatSectionButtons'
import Alert from '../Alert'
import {
    aiRequestNotAllowed,
    ajaxNewChatVC,
    ajaxTyping,
    clearChatAttachments,
    getRequestedVia,
    noAiResponseWarning,
    resetFeedbackPrompt,
    secondsToDhms,
    setLoading,
    setTimerInterval,
    warnNoChat,
    warnUserDidntRequestedChat
} from '../redux/FeedbackRedux'
import AiButton from './AiButton'

import { TypeAnimation } from 'react-type-animation'

class ChatSection extends React.Component {

    constructor(props) {
        super(props);

        const id = this.props.feedback_id;
        const storage_typing_messages = localStorage.getItem("typing_messages");
        const typing_message = storage_typing_messages === null ? [] : JSON.parse(storage_typing_messages);
        const saved_message = typing_message.filter(message => message.id === this.props.feedback_id )

        this.state = {
            value: saved_message.length > 0 ? saved_message[0].message : '',
            initial_feedback: id,
            cleared: false,
            last_typing: Math.floor(Date.now() / 1000),
            sent_first: false,
            timeSinceFeedBackStarted: this.handleTimeSinceFeedBackStarted(),
            typing_message: typing_message,
            seconds: 15,
            isAiPreviewVisible: null,
            prompt_output: ""
        };

        this.handleTick = this.handleTick.bind(this)
        this.handleClickAiButton = this.handleClickAiButton.bind(this)
        this.clearTimer = this.clearTimer.bind(this);
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
        this.calcTextareaHeight = this.calcTextareaHeight.bind(this);
    }

    calcTextareaHeight() {
        const textareas = document.querySelectorAll(".chat-dialog-textarea");

        textareas.forEach(textarea => {
            textarea.style.height = "";
            textarea.style.height = textarea.scrollHeight + "px";
        });
    }

    pasteMessage(data) {
        this.setState({ isAiPreviewVisible: false });

        this.handleChatType();

        this.saveToTypingMessage(data);
        this.setState(
            { value: data }, () => {
                this.calcTextareaHeight();
            }
        );
    }

    handlePreCanned(event) {
        event.preventDefault();

        this.handleChatType();

        if (!(this.props.feedback.is_include_contact && this.props.feedback.user.phone)) {
            warnNoChat(this.props.feedback.is_include_contact, this.props.dispatch);
            return;
        }
        var data = jQuery(event.target).attr('data-text');
        this.saveToTypingMessage(data);
        this.setState(
            { value: data }, () => {
                jQuery("#chat-textarea").trigger("input");
                this.calcTextareaHeight();
            }
        );
    }

    handleClickAiButton(event) {
        if (this.props.feedback.chat_status !== 'Chat Not Started') {
            aiRequestNotAllowed(this.props.dispatch);
            return;
        }
        this.props.dispatch(setLoading({
            loading: true,
            location: 'aiButton',
            loadingData: {'feedbackId': this.props.feedback.feedback_id}
        }));

        fetch('/feedback/' + this.props.feedback.feedback_id + '/ai/last-prompt', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(res => res.json())
        .then(response => {
            if (!response.errors) {
                const data = response.promptOutput;
                this.saveToTypingMessage(data);
                this.setState(
                    {value: data, seconds: 15}, () => {
                        let element = document.getElementById('chat-textarea');
                        element.focus();
                        this.calcTextareaHeight();
                    }
                );
                clearInterval(this.interval)
                this.props.dispatch(setLoading({loading: false, location: 'aiButton', data: null}));
            }
        })
        .catch((err) => {
            this.props.dispatch(setLoading({loading: false, location: 'aiButton'}));
        });
    }

    handleTick() {
        // start timer after button is clicked
        this.handleClickAiButton()
        this.interval = setInterval(() => {
            if (this.state.seconds !== 0) {
                this.setState(prevState => ({
                    seconds: prevState.seconds - 1
                }));
            } else {
                this.setState({ seconds: 15 })
                noAiResponseWarning(this.props.dispatch)
                this.props.dispatch(setLoading({loading: false, location: undefined, data: undefined}));
                clearInterval(this.interval);
            }
        }, 1000);
    }

    saveToTypingMessage(message) {
        if (message === "") return this.removeTypingMessage();
        if (this.state.typing_message.findIndex((value) => {
            if (value.id === this.state.initial_feedback) {
                return true;
            } else {
                return false;
            }
        }) === -1) {
            this.setState({
                typing_message: [...this.state.typing_message, {id: this.state.initial_feedback, message: message}]
            }, () => {
                localStorage.setItem("typing_messages", JSON.stringify(this.state.typing_message));
            })
        } else {
            this.setState({
                typing_message: this.state.typing_message.map((value) => {
                    if (value.id === this.state.initial_feedback)
                        return { id: this.state.initial_feedback, message: message };
                    else {
                        return value;
                    }
                })
            }, () => {
                localStorage.setItem("typing_messages", JSON.stringify(this.state.typing_message));
            })
        }
    }

    removeTypingMessage() {
        this.setState({
            typing_message: this.state.typing_message.filter((value) => {
                return value.id !== this.state.initial_feedback;
            })
        }, () => {
            localStorage.setItem("typing_messages", JSON.stringify(this.state.typing_message));
        })
    }

    handleReview(event) {
        event.preventDefault();
        if (!(this.props.feedback.is_include_contact && this.props.feedback.user.phone)) {
            warnNoChat(this.props.feedback.is_include_contact, this.props.dispatch);
            return;
        }
        var data = jQuery(event.target).attr('data-text');
        this.setState(
            { value: data },
            () => {
                jQuery("#chat-textarea").trigger("input");
                this.calcTextareaHeight();
            }
        );
    }

    handleReviewOnly(event) {
        event.preventDefault();

        if (!(this.props.feedback.is_include_contact && this.props.feedback.user.phone)) {
            warnNoChat(this.props.feedback.is_include_contact, this.props.dispatch);
            return;
        }

        const dataText = jQuery(event.target).attr('data-text');
        jQuery(".chat-dialog-textarea").each((i, elem) => {
            let textareaVal = jQuery(elem).val() + " " + dataText;
            textareaVal = textareaVal.replace(/\s+/g, ' ').trim();

            this.setState(
                { value: textareaVal },
                () => {
                    jQuery(elem).val(textareaVal).trigger("input");
                    this.calcTextareaHeight();
                }
            );
        });
    }

    handleTimeSinceFeedBackStarted() {
        if (!this.props.feedback?.timeStart) {
            return "";
        }
        const startDate = new Date(this.props.feedback.timeStart);
        const endDate = new Date();
        const seconds = (+endDate - +startDate) / 1000;

        return secondsToDhms(seconds, false, true);
    }

    handleChange(event) {
        this.setState(
            { value: event.target.value }
        );
        this.saveToTypingMessage(event.target.value);
        if (this.state.cleared !== false) {
            this.setState({
                cleared: false,
            });
        }
        const now = Math.floor(Date.now() / 1000);
        if (this.state.sent_first === true) {
            if (now > (this.state.last_typing + 2)) {
                this.props.dispatch(ajaxTyping(this.props.feedback.feedback_id, true));
                this.setState(
                    { last_typing: now }
                );
            }
        } else {
            this.props.dispatch(ajaxTyping(this.props.feedback.feedback_id, true));
            this.setState(
                { last_typing: now, sent_first: true }
            );
        }

        event.target.style.height = ""; // Reset height
        event.target.style.height = event.target.scrollHeight + "px"; // Adjust height dynamically
    }

    handleClick() {
        if (!(this.props.feedback.is_include_contact && this.props.feedback.user.phone)) {
            warnNoChat(this.props.feedback.is_include_contact, this.props.dispatch);
            return;
        }
        if (this.props.loading === false && (this.state.value !== '' || window.chatAttachments.length > 0)) {
            this.props.dispatch(ajaxTyping(this.props.feedback.feedback_id, false));
            this.props.dispatch(ajaxNewChatVC(this.state.value, this.props.feedback.feedback_id));
            this.removeTypingMessage();
            clearChatAttachments();
        }
        this.setState({ value: '' });
        if (this.props.feedbackPrompt)
            this.props.dispatch(resetFeedbackPrompt())
    }

    handleTextClick(event) {
        if (!(this.props.feedback.is_include_contact && this.props.feedback.user.phone)) {
            warnNoChat(this.props.feedback.is_include_contact, this.props.dispatch);
            return;
        }
        if (event.target.value == "") {
            this.removeTypingMessage();
            this.setState(
                { value: '' }
            );
        }
    }

    handleGpsRequest(event) {
        event.preventDefault();

        if (!(this.props.feedback.is_include_contact && this.props.feedback.user.phone)) {
            warnNoChat(this.props.feedback.is_include_contact, this.props.dispatch);
            return;
        }

        const data = event.target.getAttribute('data-text');
        this.saveToTypingMessage(data);
        this.setState(
            { value: data },
            () => {
                const chatTextarea = document.getElementById("chat-textarea");
                if (chatTextarea) {
                    const inputEvent = new Event("input", { bubbles: true, cancelable: true });
                    chatTextarea.dispatchEvent(inputEvent);
                }
            }
        );
    }

    handleChatType() {
        if (!this.props.feedback.is_text && !this.props.feedback.is_whatsapp && this.props.feedback.user.phone) {
            if (!this.props.chatAnyway) {
                warnUserDidntRequestedChat(this.props.dispatch);
            }
        }
    }

    clearTimer() {
        clearInterval(this.interval)
        if (this.props.feedbackPrompt)
            this.setState({ value: this.props.feedbackPrompt, seconds: 15 })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.initial_feedback !== this.props.feedback_id) {
            const saved_message_index = this.state.typing_message.findIndex((value) => {
                if (value.id === this.props.feedback_id) {
                    return true;
                } else {
                    return false;
                }
            });
            this.setState({
                value: saved_message_index === -1 ? "" : this.state.typing_message[saved_message_index].message,
                initial_feedback: this.props.feedback_id,
                cleared: true,
            });
            this.calcTextareaHeight();
        }

        if (this.props.feedbackPrompt === prevProps.feedbackPrompt && this.props.loading) {
            let element = document.getElementById('chat-textarea');
            element.focus();
            this.calcTextareaHeight();
        }

        if (this.props.feedbackPrompt !== prevProps.feedbackPrompt) {
            this.clearTimer()
        }

        if (this.state.value !== prevState.value) {
            let element = document.getElementById('chat-textarea');
            element.focus();
            this.calcTextareaHeight();
            this.saveToTypingMessage(this.state.value)
        }

        //
        const AIGenRecommendation = this.props?.feedback?.prompts[0]?.prompt_output;

        if (AIGenRecommendation !== this.state.prompt_output) {
            if (!AIGenRecommendation || AIGenRecommendation.length < 1) {
                if (this.state.isAiPreviewVisible !== false) {
                    this.setState({ isAiPreviewVisible: false });
                }
            } else {
                if (this.props.feedback.chat_status === 'Chat Not Started') {
                    this.setState({ isAiPreviewVisible: true });
                } else {
                    this.setState({ isAiPreviewVisible: false });
                }

                if (this.state.prompt_output !== AIGenRecommendation) {
                    this.setState({ prompt_output: AIGenRecommendation });
                }
            }
        }
    }

    UNSAFE_componentWillReceiveProps() {
        if (this.props.loading) {
            this.clearTimer()
        }
    }

    componentDidMount() {
        this.props.dispatch(setTimerInterval());

        setInterval(() => {
            this.setState({ timeSinceFeedBackStarted: this.handleTimeSinceFeedBackStarted() })
        }, 1000);
        if (document.getElementById('chat-textarea')) {
            this.calcTextareaHeight();
        }
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
        clearInterval(this.interval);
    }

    render() {
        let isSafari = false;

        if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
            isSafari = true;
        }

        // condition to show AI Button & Preview
        const showAIButton = Boolean(this.props.current_user && ((this.props.feedback.is_include_contact && this.props.feedback.user.phone)
        || (this.props.feedback.is_whatsapp && this.props.feedback.chats.length === 1)));

        return (
            <div className="chat chat--fullheight h-100 d-flex flex-column" id="chatsection">
                <div className="mb-0 p-3 border-bottom">
                    <h5 id="chat" className="d-inline">Chat</h5>
                    {this.props.feedback.response_time && !this.props.feedback.getLastChatIfFeedbacker ? <span className="float-right text-muted" style={{fontSize: '0.64rem'}}>{__('Response time')}: {this.props.feedback.response_time}</span> : null}
                    {((this.props.feedback.chat_status === "Chat Not Started" && this.props.feedback.is_include_contact && this.props.feedback.user.phone && (this.props.feedback.is_whatsapp || this.props.feedback.is_text)) ?
                        <span className="float-right chat-alert-message pb-0 pt-0 mb-0 mt-0 anim-pulse d-inline" style={{fontSize: '0.64rem'}}><i className="fas fa-exclamation-triangle text-warning mr-1"></i>{__('Not yet responded to')}&nbsp;({this.state.timeSinceFeedBackStarted} {__('since submitted')})</span> : "")}
                    {((this.props.feedback.chat_status !== "Chat Not Started" && this.props.feedback.getLastChatIfFeedbacker && this.props.feedback.is_include_contact && this.props.feedback.user.phone && (this.props.feedback.is_whatsapp || this.props.feedback.is_text)) ?
                        <span className="float-right chat-alert-message pb-0 pt-0 mb-0 mt-0 anim-pulse d-inline"  style={{fontSize: '0.64rem'}}><i className="fas fa-exclamation-triangle text-warning mr-1"></i>{__('New Chat not responded to')}&nbsp;({this.state.timeSinceFeedBackStarted} )</span> : "")}
                    {(!this.props.feedback.is_text && !this.props.feedback.is_whatsapp && this.props.feedback.user.phone) &&
                        <span className={this.props.feedback.otf_id ? 'float-right font-weight-bold' : "float-right"} style={{fontSize: '0.64rem'}}>( {__('This customer did not request a response via chat')}. {getRequestedVia(this.props.feedback)} )</span>
                    }
                </div>

                <div className="p-3 h-100 chat_widget" id="chat_widget">
                    {(this.props.current_user && (typeof this.props.feedback.include_user_details == "undefined" || this.props.feedback.include_user_details != false)) &&
                        this.props.feedback.chats.length > 0 ? <Chats /> : null
                    }
                    {(!this.props.current_user || !(typeof this.props.feedback.include_user_details == "undefined" || this.props.feedback.include_user_details == false)) &&
                        this.props.feedback.chats.length > 0 ? <Chats hidename={true} /> : null
                    }
                    <Typing />
                </div>

                <div className="text-right" id="feedback_attachment_div">
                    <div id="feedback_attachments_preview" className="align-items-center justify-content-end d-flex"></div>
                    <input type="file" className="feedback_attachment" multiple name="feedback_attachment[]"
                        id="feedback_attachment_1"
                        accept="image/png, image/jpeg, image/*, video/mp4, video/quicktime, video/H264, video/mpeg, video/webm, application/pdf" />
                </div>

                <div className='pt-3 border-top'>
                    {/* AI Generated Recommendation Preview */}
                    {this.state.prompt_output && this.state.isAiPreviewVisible && this.props.feedback.chat_status === 'Chat Not Started' && showAIButton &&
                        <div className='chat-ai-recommendation-wrapper px-2' data-visible={this.state.isAiPreviewVisible}>
                            <p className='textarea-label'>{__('AI Generated Recommendation')}</p>

                            <div className='chat-ai-recommendation-text'>
                                <svg width="20" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.125 10.333V1L1 15.667h7.875V25L19 10.333h-7.875Z" fill="#3775B7" stroke="#3775B7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <TypeAnimation
                                    key={this.state.prompt_output.length}
                                    sequence={[
                                        // Same substring at the start will only be typed out once, initially
                                        this.state.prompt_output,
                                    ]}
                                    wrapper="p"
                                    speed={100}
                                    style={{ fontSize: '0.8rem', display: 'inline-block' }}
                                    repeat={0}
                                    className="ai-suggestion-type"
                                />
                            </div>

                            <div className='chat-ai-recommendation-buttons'>
                                <button className='btn-text' onClick={this.pasteMessage.bind(this, this.state.prompt_output)}>{__('Paste to Message')}</button>
                            </div>
                        </div>
                    }

                    {/* Buttons Wrapper */}
                    <div className='chat-buttons-wrapper px-2'>
                        {/* AI Button */}
                        {!this.state.isAiPreviewVisible && showAIButton
                            ? <AiButton location={'aiButton'} handleTick={this.handleTick} seconds={this.state.seconds} />
                            : null
                        }

                        {/* Insert Rating & Canned Responses */}
                        {this.props.current_user && <ChatSectionButtons handleReview={this.handleReview.bind(this)} handleReviewOnly={this.handleReviewOnly.bind(this)} handlePreCanned={this.handlePreCanned.bind(this)} />}

                        {/* Request GPS */}
                        {(this.props.feedback.allow_gps_feedback && this.props.current_user && ((this.props.feedback.is_include_contact && this.props.feedback.user.phone)
                            || (this.props.feedback.is_whatsapp && this.props.feedback.chats.length === 1)))
                            ? <div className="d-flex justify-content-center btn-spacer">
                                <button
                                    className="btn btn-md btn-primary btn-primary-alt no-arrow text-nowrap btn-chat"
                                    data-text={__('Can you share your current GPS location so we can better assist you? If so, please click the link below to allow a one-time sharing of your current location') + ':\nhttps://' + this.props.feedback.friendly_access_url + '/gps/' + this.props.feedback.short_id}
                                    onClick={this.handleGpsRequest.bind(this)}
                                    type="button"
                                >
                                    <svg className='ml-1 mr-1' width="11" height="11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#a)">
                                            <path d="M9.625 5.5A4.125 4.125 0 0 1 5.5 9.625M9.625 5.5A4.125 4.125 0 0 0 5.5 1.375M9.625 5.5h-8.25M5.5 9.625A4.125 4.125 0 0 1 1.375 5.5M5.5 9.625c.76 0 1.375-1.847 1.375-4.125S6.259 1.375 5.5 1.375m0 8.25c-.76 0-1.375-1.847-1.375-4.125S4.741 1.375 5.5 1.375m0 0A4.125 4.125 0 0 0 1.375 5.5"
                                            stroke="#3775B7"
                                            strokeWidth=".917"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"/>
                                        </g>
                                        <defs>
                                            <clipPath id="a">
                                                <path fill="#fff" d="M0 0h11v11H0z"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    {__('Request GPS')}
                                </button>
                            </div>
                            : null
                        }
                    </div>

                    {this.props.current_user &&
                        <div className="px-2 mt-0 w-100 d-flex flex-column align-items-center pb-2">
                            {/* Textarea */}
                            <div className='row w-100'>
                                <textarea
                                    onChange={(e) => {
                                        this.handleChange(e)
                                    }}
                                    onKeyUp={this.handleChatType.bind(this)}
                                    onClick={this.handleTextClick.bind(this)}
                                    id="chat-textarea"
                                    value={this.state.value}
                                    style={{
                                        resize: "none",
                                        minHeight: "50px",
                                        maxHeight: "none",
                                    }}
                                    className="chat-dialog-textarea"
                                    placeholder={(this.props.feedback.is_whatsapp && this.props.feedback.chats.length === 1) ? __("Whatsapp's regulations require the user to respond before another message can be sent.") : __("Type your message") + '...'}
                                    aria-label={__("Type your message") + '...'}
                                    readOnly={((!(this.props.feedback.is_include_contact && this.props.feedback.user.phone) || (this.props.feedback.is_whatsapp && this.props.feedback.chats.length === 1)) ? "readOnly" : false)}
                                />
                            </div>

                            <div className='row flex-row justify-content-between w-100 pt-3'>
                                <label htmlFor="feedback_attachment_1" id="feedback_attachment_label" className="mb-0">
                                    <img className="notes-icon" src="/img/chat-attachment.svg" data-toggle="tooltip" data-placement="bottom" data-title={__('Attach file(s) to your message')} />
                                </label>
                                <button className={this.props.loading
                                        ? "disabled btn btn-sm btn-primary p-2"
                                        : ("btn btn-sm" + (
                                            !(this.props.feedback.is_include_contact && this.props.feedback.user.phone) || (this.props.feedback.is_whatsapp && this.props.feedback.chats.length === 1)
                                                ? " btn-secondary"
                                                : " btn-primary p-2")
                                        )}
                                        onClick={this.handleClick.bind(this)}
                                        type="button">
                                    <img src="/img/send-white.svg" />
                                </button>
                            </div>

                        </div>
                    }
                </div>

                <div className="mt-1 mb-1">
                    <Alert alert={this.props.alert} location={'chat'}  />
                </div>

            </div>

        );
    }
}

function mapStateToProps(state) {
    return {
        feedback: state.feedback_detail,
        loading: state.loading,
        loading_location: state.loading_location,
        loading_data: state.loading_data,
        feedback_id: state.selected_feedback,
        alert: state.alert,
        feedbackPrompt: state.feedbackPrompt,
        current_user: state.current_user,
        chatAnyway: state.chatAnyway,
        responseSuggestion: state.responseSuggestion,
        errorResponseSuggestion: state.errorResponseSuggestion
    }
}

export default connect(mapStateToProps)(ChatSection);
